// src/utils/logoLoader.js

function importAll(r) {
    let images = {};
    r.keys().forEach((filePath) => {
      // filePath vem algo como "./propal.jpg" ou "./LidaWeb/nfe.png"
      const fileName = filePath.replace('./', ''); 
      // fileName será "propal.jpg" ou "LidaWeb/nfe.png"
      images[fileName] = r(filePath);
    });
    return images;
  }
  
  // O 1º parâmetro do require.context é o diretório base
  // O 2º parâmetro indica se deve buscar recursivamente subpastas (true/false)
  // O 3º é uma expressão regular para tipos de arquivo que queremos importar
  const images = importAll(require.context('../assets/logos', true, /\.(png|jpe?g|svg)$/));
  
  export default images;
  